var _path, _g, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThankYouIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 956,
    height: 956,
    viewBox: "0 0 956 956",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432.14 26.4774C460.518 10.0931 495.482 10.0931 523.86 26.4775L846.1 212.523C874.478 228.907 891.96 259.186 891.96 291.955V664.045C891.96 696.814 874.478 727.093 846.1 743.477L523.86 929.523C495.482 945.907 460.518 945.907 432.14 929.523L109.9 743.477C81.5217 727.093 64.0399 696.814 64.0399 664.045V291.955C64.0399 259.186 81.5217 228.907 109.9 212.523L432.14 26.4774Z",
    fill: "url(#paint0_linear_915_1513)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_915_1513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.95 73.6376C460.328 57.2533 495.292 57.2533 523.67 73.6376L805.066 236.101C833.444 252.486 850.926 282.765 850.926 315.534V640.461C850.926 673.23 833.444 703.509 805.066 719.894L523.67 882.357C495.292 898.742 460.328 898.742 431.95 882.357L150.554 719.894C122.176 703.509 104.694 673.23 104.694 640.461V315.534C104.694 282.765 122.176 252.486 150.554 236.101L431.95 73.6376Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M443.065 467.195C440.2 464.33 436.315 462.721 432.264 462.721C428.212 462.721 424.327 464.33 421.462 467.195C418.598 470.059 416.988 473.945 416.988 477.996C416.988 482.047 418.598 485.933 421.462 488.797L467.102 534.437C468.523 535.847 470.209 536.963 472.063 537.72C473.916 538.477 475.901 538.86 477.903 538.849C479.986 538.783 482.033 538.29 483.917 537.4C485.801 536.51 487.483 535.243 488.857 533.676L595.349 411.971C597.808 408.918 598.994 405.034 598.659 401.128C598.324 397.223 596.494 393.597 593.551 391.007C590.608 388.418 586.78 387.064 582.863 387.228C578.947 387.393 575.245 389.062 572.529 391.89L477.903 501.424L443.065 467.195Z",
    fill: "url(#paint1_linear_915_1513)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M614.829 462.78C610.794 462.78 606.924 464.383 604.071 467.236C601.218 470.089 599.615 473.958 599.615 477.993C599.615 510.271 586.793 541.228 563.969 564.052C541.144 586.876 510.188 599.699 477.91 599.699C453.874 599.688 430.38 592.56 410.39 579.215C390.4 565.869 374.809 546.904 365.583 524.709C356.357 502.515 353.909 478.086 358.549 454.502C363.188 430.919 374.706 409.237 391.651 392.191C402.92 380.772 416.353 371.714 431.164 365.55C445.975 359.385 461.867 356.236 477.91 356.288C487.638 356.349 497.33 357.471 506.815 359.635C508.8 360.249 510.889 360.449 512.955 360.225C515.02 360 517.018 359.355 518.824 358.329C520.631 357.303 522.208 355.918 523.459 354.259C524.709 352.6 525.607 350.702 526.096 348.683C526.585 346.664 526.656 344.566 526.303 342.518C525.95 340.471 525.182 338.517 524.045 336.778C522.909 335.039 521.428 333.551 519.694 332.406C517.961 331.261 516.011 330.484 513.965 330.121C502.147 327.341 490.051 325.912 477.91 325.861C447.854 326.017 418.517 335.073 393.603 351.886C368.689 368.698 349.312 392.514 337.92 420.328C326.528 448.142 323.629 478.707 329.591 508.166C335.553 537.626 350.107 564.659 371.418 585.855C399.664 614.114 437.955 630.032 477.91 630.125C518.258 630.125 556.953 614.097 585.483 585.567C614.014 557.036 630.042 518.341 630.042 477.993C630.042 473.958 628.439 470.089 625.586 467.236C622.733 464.383 618.863 462.78 614.829 462.78Z",
    fill: "url(#paint2_linear_915_1513)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_915_1513",
    x: 86.3492,
    y: 61.3496,
    width: 782.921,
    height: 869.985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.3441
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.17206
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_915_1513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_915_1513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_915_1513",
    x1: 478,
    y1: 0,
    x2: 478,
    y2: 956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77D23E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FD83E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_915_1513",
    x1: 507.851,
    y1: 387.215,
    x2: 507.851,
    y2: 538.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77D23E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FD83E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_915_1513",
    x1: 478.305,
    y1: 325.861,
    x2: 478.305,
    y2: 630.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77D23E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FD83E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYouIcon);
export default __webpack_public_path__ + "static/media/thank-you-icon.d645ff6a90b7c901869ad07f778b1586.svg";
export { ForwardRef as ReactComponent };